import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { ModeloVeiculo } from "../typings";

export function useListarModelosVeiculo(marcaId?: string) {
  return useQuery<ModeloVeiculo[], AxiosError>(
    `/v1/veiculo/marcas/${marcaId}/modelos`,
    async () => {
      const {data} = await http.get<ModeloVeiculo[]>(`/v1/veiculo/marcas/${marcaId}/modelos`);

      return data;
    },
    {enabled: !!marcaId}
  );
}
